/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import styled from 'styled-components';
import PropTypes from 'prop-types';
/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
import theme from '../../styles/theme';

const FormWrap = styled.form`
  position: absolute;
  z-index: 10;
  right: 200px;
  margin: 3px 0;
  margin-right: 20px;
  transition-property: width, padding;
  transition-duration: 0.3s;
  width: ${props => (props.open ? '500px' : '15px')};
  background: ${props => (props.useDarkBackground ? `${theme.navbar.dark}` : `${theme.navbar.light}`)};
  
  .search-input {
    position: relative;
    width: calc(100% + 20px);
    min-width: 35px;
    min-height: 35px;
    max-height: 35px;
    background: rgba(255, 255, 255, 0.0001);
    border: 1px solid ${props => (props.useDarkBackground ? `${theme.body.dark}` : `${theme.body.light}`)};
    border-radius: 20px;
    svg {
      position: absolute;
      width: 100%;
      top: 0px;
      padding: 7px 10px 10px;
      width: 35px;
      height: 35px;
      fill: #FFFFFF;
      background: rgba(255, 255, 255, 0.001);
      outline: none;
      -webkit-tap-highlight-color: transparent;

      path {
        transition-delay: ${props => (props.toggleOpen ? '0.3s' : 'none')};
        fill: ${props => (props.useDarkBackground || props.toggleOpen ? `${theme.body.dark}` : `${theme.body.light}`)};
      }
      :hover {
        cursor: pointer;
        outline: none;
      }
    }
    .autocomplete-wrapper {
      .aa-Autocomplete {
        .aa-Form {
          border: none;
          box-shadow: none;
          background: transparent;

          .aa-InputWrapperPrefix,
          .aa-InputWrapperSuffix {
            display: none;
          }
          .aa-InputWrapper {
            .aa-Input {
              background: rgba(255, 255, 255, 0.001);
              color: ${props => (props.useDarkBackground || props.toggleOpen ? `${theme.body.dark}` : `${theme.body.light}`)};
              height: 35px;
              padding: 0 0 0 40px;
            }
          }
        }
      }
    }
  }

  @media(max-width: 989px) {
    margin-top: 1px;
    right: 50px;
    height: 0px;
    width: ${props => (props.open ? '50%' : '15px')};
  }
  @media(max-width: 767px) {
    margin-top: 1px;
    width: ${props => (props.open ? 'calc(100% - 110px)' : '15px')};
    .search-input {
      border: ${props => (props.open ? '1px' : '0px')} solid ${props => (props.useDarkBackground || props.toggleOpen ? `${theme.body.dark}` : `${theme.body.light}`)};
    }
  }
`;

FormWrap.defaultProps = {
  useDarkBackground: false,
  open: false,
  toggleOpen: false,
};
FormWrap.propTypes = {
  useDarkBackground: PropTypes.bool,
  open: PropTypes.bool,
  toggleOpen: PropTypes.bool,
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default FormWrap;
